import { fetchTradingSessionCookieProbe } from './services';

/**
 * `blocked` means the browser dropped our cross-site trading cookie (WebKit's
 * third-party cookie policy on iOS Safari and in-app browsers), so minting a
 * session would waste the user's signature. `unknown` is the fail-open answer
 * (backend without the probe route, network trouble, non-https page) and must
 * never gate anything.
 */
export type TradingSessionCookieSupport = 'supported' | 'blocked' | 'unknown';

/**
 * Calls the probe twice: the first response sets the probe cookie, the second
 * reports whether the browser sent it back.
 *
 * `location` is injected for tests only. On an http page (local dev) the
 * `__Secure-` probe cookie can never land, so we answer `unknown` without
 * touching the network instead of walling off development with a false
 * `blocked`.
 */
export async function probeTradingSessionCookieSupport(
    location: Pick<Location, 'protocol'> = window.location,
): Promise<TradingSessionCookieSupport> {
    if (location.protocol !== 'https:') return 'unknown';
    try {
        await fetchTradingSessionCookieProbe();
        const echo = await fetchTradingSessionCookieProbe();
        return echo.cookieReceived ? 'supported' : 'blocked';
    } catch {
        return 'unknown';
    }
}
